module.exports = __webpack_public_path__ + "img/medical-kit.3cc14209.svg";